import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import LocalStorageService from "../../../services/localStorage";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { formattedDateYYMMDD } from "../../../utils/date";
import { ACTION_FLAG_ACTIVE_LABEL, ACTION_FLAG_ACTIVE_VALUE, ACTION_FLAG_INACTIVE_LABEL, ALERT_ADD_PAYMENT_MODE, ALERT_ADD_PLANS, ALERT_ADD_RECURRENCE, ALERT_CREATE_CAMPAIGN, AVATAR_ENTITY_PROJECT, DELETE_ENTITY_PAYMENT_MODE, DELETE_ENTITY_RECURRENCE, DELETE_TITLE_PAYMENT_MODE, DELETE_TITLE_RECURRENCE, deleteSubTitlePaymentMode, deleteSubTitleRecurrence, LOADING_TEXT, PANEL_PLANS, PANEL_RECURRENCE, PRODUCT_ALERT_AUTO_CLOSE, PRODUCT_CAMPAIGN_PROJECT_STATUS, PRODUCT_CATALOG_LIMIT, PRODUCT_DEFAULT_PAGE, PRODUCT_PERMISSIONS, PRODUCT_PLANS_LIMIT, routePlanCreation, TOAST_CAMPAIGN_CREATED, TOAST_CAMPAIGN_UPDATED, TOAST_PAYMENT_MODE_ADDED, TOAST_PRODUCT_CREATED, TOAST_PRODUCT_UPDATED, TOAST_RECURRENCE_ADDED, UPDATING_TEXT, } from "../constants/productCreation.constants";
import { buildFlagsColumns, buildPaymentModeColumns, buildPlansColumns, buildRecurrenceColumns, } from "../constants/productCreation.columns";
import { INITIAL_CAMPAIGN_FORM, INITIAL_PRODUCT_FORM, } from "../constants/productCreation.forms";
import { useDeleteProductEntity } from "./useDeleteProductEntity";
import { useGetCampaign } from "./useGetCampaign";
import { useGetProduct } from "./useGetProduct";
import { useGetProductPlans } from "./useGetProductPlans";
import { useProductAccountTypes } from "./useProductAccountTypes";
import { useProductActionFlags } from "./useProductActionFlags";
import { useProductCreationErrorHandling } from "./useProductCreationErrorHandling";
import { useProductCreationLookups } from "./useProductCreationLookups";
import { useProductPaymentRecurrences } from "./useProductPaymentRecurrences";
import { useSaveCampaign } from "./useSaveCampaign";
import { useSaveProduct } from "./useSaveProduct";
import { useUploadProductAvatar } from "./useUploadProductAvatar";
var lsLogin = new LocalStorageService("assurehub");
var HIDDEN_TOAST = {
    show: false,
    message: "",
    type: typeAlert.success,
};
export var useProductCreation = function () {
    var _a, _b;
    var navigate = useNavigate();
    var _c = useParams(), idProduct = _c.idProduct, isEdit = _c.isEdit, plans = _c.plans;
    var clientId = useState(function () { return lsLogin.getUserLoginStored().clientId; })[0];
    var _d = useState(true), disableCampaign = _d[0], setDisableCampaign = _d[1];
    var _e = useState(true), disableRecurrence = _e[0], setDisableRecurrence = _e[1];
    var _f = useState(true), disablePaymentMode = _f[0], setDisablePaymentMode = _f[1];
    var _g = useState(true), disablePlans = _g[0], setDisablePlans = _g[1];
    var _h = useState(true), disableFlags = _h[0], setDisableFlags = _h[1];
    var _j = useState(true), activateEditProduct = _j[0], setActivateEditProduct = _j[1];
    var _k = useState(true), activateEditCampaign = _k[0], setActivateEditCampaign = _k[1];
    var _l = useState(false), showCancelButton = _l[0], setShowCancelButton = _l[1];
    var _m = useState(true), showAddButtonRecurrence = _m[0], setShowAddButtonRecurrence = _m[1];
    var _o = useState(true), showAddButtonPaymentMode = _o[0], setShowAddButtonPaymentMode = _o[1];
    var _p = useState(true), showAddButtonPlans = _p[0], setShowAddButtonPlans = _p[1];
    var _q = useState(true), showButtonsActions = _q[0], setShowButtonsActions = _q[1];
    var _r = useState(true), showButtonAddCampaign = _r[0], setShowButtonAddCampaign = _r[1];
    var _s = useState(true), showUploadButton = _s[0], setShowUploadButton = _s[1];
    var _t = useState(false), openModal = _t[0], setOpenModal = _t[1];
    var _u = useState(false), openDrawerPaymentR = _u[0], setOpenDrawerPaymentR = _u[1];
    var _v = useState(false), openDrawerPaymentM = _v[0], setOpenDrawerPaymentM = _v[1];
    var _w = useState(INITIAL_PRODUCT_FORM), dataProductCreation = _w[0], setDataProductCreation = _w[1];
    var _x = useState(INITIAL_CAMPAIGN_FORM), dataCampaignCreation = _x[0], setDataCampaignCreation = _x[1];
    var _y = useState(false), isUpdate = _y[0], setIsUpdate = _y[1];
    var _z = useState(""), projectId = _z[0], setProjectId = _z[1];
    var _0 = useState(""), campaignId = _0[0], setCampaignId = _0[1];
    var _1 = useState(null), deleteModal = _1[0], setDeleteModal = _1[1];
    var _2 = useState(HIDDEN_TOAST), seeToast = _2[0], setSeeToast = _2[1];
    var _3 = useState(false), showAlert = _3[0], setShowAlert = _3[1];
    var _4 = useState(""), descriptionAlert = _4[0], setDescriptionAlert = _4[1];
    var _5 = useState(0), panelActive = _5[0], setPanelActive = _5[1];
    var _6 = useState(null), uploadedImage = _6[0], setUploadedImage = _6[1];
    var _7 = useState(""), imgProject = _7[0], setImgProject = _7[1];
    var currentProjectId = projectId || idProduct || "";
    var canEdit = !idProduct || isEdit === "true";
    var lookups = useProductCreationLookups(clientId);
    var product = useGetProduct();
    var saveProduct = useSaveProduct();
    var campaign = useGetCampaign();
    var saveCampaign = useSaveCampaign();
    var recurrences = useProductPaymentRecurrences();
    var accountTypes = useProductAccountTypes();
    var productPlans = useGetProductPlans();
    var actionFlags = useProductActionFlags();
    var avatar = useUploadProductAvatar();
    var deleteEntity = useDeleteProductEntity();
    useProductCreationErrorHandling({
        errorLookups: lookups.errors,
        errorProduct: product.error,
        errorCreateProduct: saveProduct.errorCreate,
        errorUpdateProduct: saveProduct.errorUpdate,
        errorCampaign: campaign.error,
        errorCreateCampaign: saveCampaign.errorCreate,
        errorUpdateCampaign: saveCampaign.errorUpdate,
        errorLinkCampaign: saveCampaign.errorLink,
        errorRecurrences: recurrences.errorList,
        errorCreateRecurrence: recurrences.errorCreate,
        errorAccountTypes: accountTypes.errorList,
        errorCreateAccountType: accountTypes.errorCreate,
        errorPlans: productPlans.error,
        errorAvatar: avatar.error,
        errorDelete: deleteEntity.error,
        setSeeToast: setSeeToast,
    });
    var loadRecurrences = function (id) {
        if (!id)
            return;
        recurrences.fetch({
            enable: true,
            page: PRODUCT_DEFAULT_PAGE,
            limit: PRODUCT_CATALOG_LIMIT,
            projectId: id,
            deleted: false,
        });
    };
    var loadAccountTypes = function (id) {
        if (!id)
            return;
        accountTypes.fetch({
            enable: true,
            page: PRODUCT_DEFAULT_PAGE,
            limit: PRODUCT_CATALOG_LIMIT,
            clientId: clientId,
            projectId: id,
            deleted: false,
        });
    };
    var loadPlans = function (id) {
        productPlans.fetch({
            enable: true,
            page: PRODUCT_DEFAULT_PAGE,
            limit: PRODUCT_PLANS_LIMIT,
            projectId: id,
            clientId: clientId,
        });
    };
    var usedRecurrenceIds = useMemo(function () { var _a; return ((_a = recurrences.items) !== null && _a !== void 0 ? _a : []).map(function (item) { return item.catalogPaymentMode.id; }); }, [recurrences.items]);
    var usedAccountTypeIds = useMemo(function () { var _a; return ((_a = accountTypes.items) !== null && _a !== void 0 ? _a : []).map(function (item) { return item.catalogAccountType.id; }); }, [accountTypes.items]);
    var paymentModeList = useMemo(function () {
        return lookups.catalogPaymentModes.filter(function (item) { return !usedRecurrenceIds.includes(item.id); });
    }, [lookups.catalogPaymentModes, usedRecurrenceIds]);
    var accountTypeList = useMemo(function () {
        return lookups.catalogAccountTypes.filter(function (item) { return !usedAccountTypeIds.includes(item.id); });
    }, [lookups.catalogAccountTypes, usedAccountTypeIds]);
    var rowsPaymentRecurrence = useMemo(function () {
        var _a;
        return ((_a = recurrences.items) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            code: item.catalogPaymentMode.code,
            description: item.catalogPaymentMode.description,
        }); });
    }, [recurrences.items]);
    var rowsAccountType = useMemo(function () {
        var _a;
        return ((_a = accountTypes.items) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            code: item.catalogAccountType.code,
            description: item.catalogAccountType.description,
        }); });
    }, [accountTypes.items]);
    var rowsPlans = useMemo(function () {
        var _a;
        return ((_a = productPlans.plans) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            code: item.code,
            name: item.name,
            coverType: item.coverTypes.map(function (type) { return type.description; }).join(", "),
        }); });
    }, [productPlans.plans]);
    var rowsFlags = useMemo(function () {
        var _a;
        return ((_a = actionFlags.flags) !== null && _a !== void 0 ? _a : []).map(function (item) { return ({
            id: item.id,
            value: item.value === ACTION_FLAG_ACTIVE_VALUE
                ? ACTION_FLAG_ACTIVE_LABEL
                : ACTION_FLAG_INACTIVE_LABEL,
            name: item.name,
        }); });
    }, [actionFlags.flags]);
    useEffect(function () {
        if (idProduct && isEdit !== "true") {
            setDisableCampaign(false);
            setDisablePaymentMode(false);
            setDisableRecurrence(false);
            setDisablePlans(false);
            setDisableFlags(false);
            setActivateEditProduct(false);
            setActivateEditCampaign(false);
            setShowButtonsActions(false);
            setShowButtonAddCampaign(false);
            setShowAddButtonRecurrence(false);
            setShowAddButtonPaymentMode(false);
            setShowAddButtonPlans(false);
            setIsUpdate(false);
            product.fetch(idProduct);
            loadRecurrences(idProduct);
            loadAccountTypes(idProduct);
            loadPlans(idProduct);
            setShowUploadButton(false);
        }
        if (idProduct && isEdit === "true") {
            setDisableCampaign(false);
            setDisablePaymentMode(false);
            setDisableRecurrence(false);
            setDisablePlans(false);
            setDisableFlags(false);
            setActivateEditProduct(false);
            setActivateEditCampaign(false);
            setShowAddButtonRecurrence(true);
            setShowAddButtonPaymentMode(true);
            product.fetch(idProduct);
            setShowCancelButton(true);
            loadRecurrences(idProduct);
            loadAccountTypes(idProduct);
            setIsUpdate(true);
            setShowAddButtonPlans(true);
            loadPlans(idProduct);
        }
        if (idProduct && isEdit === "true" && plans === "true") {
            setPanelActive(PANEL_PLANS);
        }
    }, [idProduct, isEdit, plans]);
    useEffect(function () {
        if (!currentProjectId)
            return;
        actionFlags.fetch({
            enable: true,
            page: PRODUCT_DEFAULT_PAGE,
            limit: PRODUCT_CATALOG_LIMIT,
            projectId: currentProjectId,
        });
    }, [currentProjectId]);
    useEffect(function () {
        var created = saveProduct.createdProduct;
        if (!(created === null || created === void 0 ? void 0 : created.id))
            return;
        setShowAlert(true);
        setDescriptionAlert(ALERT_CREATE_CAMPAIGN);
        setDisableCampaign(false);
        showToastSuccessMessage(TOAST_PRODUCT_CREATED, typeAlert.success, setSeeToast);
        if (uploadedImage) {
            avatar.uploadAvatar({
                entity: AVATAR_ENTITY_PROJECT,
                id: created.id,
                image: uploadedImage,
            });
            setUploadedImage(null);
        }
        setProjectId(created.id);
        loadPlans(created.id);
        actionFlags.createDefaultFlags(created.id);
        saveProduct.clearCreated();
    }, [saveProduct.createdProduct]);
    useEffect(function () {
        if (!saveProduct.updatedProduct)
            return;
        showToastSuccessMessage(TOAST_PRODUCT_UPDATED, typeAlert.success, setSeeToast);
        saveProduct.clearUpdated();
        if (uploadedImage) {
            avatar.uploadAvatar({
                entity: AVATAR_ENTITY_PROJECT,
                id: currentProjectId,
                image: uploadedImage,
            });
            setUploadedImage(null);
        }
    }, [saveProduct.updatedProduct]);
    useEffect(function () {
        if (!avatar.avatarUploaded)
            return;
        showToastSuccessMessage(TOAST_PRODUCT_UPDATED, typeAlert.success, setSeeToast);
        avatar.clearAvatar();
    }, [avatar.avatarUploaded]);
    useEffect(function () {
        var created = saveCampaign.createdCampaign;
        if (!(created === null || created === void 0 ? void 0 : created.id))
            return;
        setShowAlert(true);
        setActivateEditProduct(false);
        setActivateEditCampaign(false);
        setDescriptionAlert(ALERT_ADD_RECURRENCE);
        showToastSuccessMessage(TOAST_CAMPAIGN_CREATED, typeAlert.success, setSeeToast);
        setDisableRecurrence(false);
        setPanelActive(PANEL_RECURRENCE);
        saveCampaign.linkCampaignToProject({
            status: PRODUCT_CAMPAIGN_PROJECT_STATUS,
            projectId: currentProjectId,
            campaignId: created.id,
        });
        setCampaignId(created.id);
        saveCampaign.clearCreated();
    }, [saveCampaign.createdCampaign]);
    useEffect(function () {
        if (!saveCampaign.updatedCampaign)
            return;
        showToastSuccessMessage(TOAST_CAMPAIGN_UPDATED, typeAlert.success, setSeeToast);
        saveCampaign.clearUpdated();
    }, [saveCampaign.updatedCampaign]);
    useEffect(function () {
        if (!recurrences.created)
            return;
        loadRecurrences(currentProjectId);
        setShowAlert(true);
        setDescriptionAlert(ALERT_ADD_PAYMENT_MODE);
        showToastSuccessMessage(TOAST_RECURRENCE_ADDED, typeAlert.success, setSeeToast);
        setOpenDrawerPaymentR(false);
        setDisablePaymentMode(false);
        recurrences.clearCreated();
    }, [recurrences.created]);
    useEffect(function () {
        if (!accountTypes.created)
            return;
        loadAccountTypes(currentProjectId);
        setShowAddButtonPlans(true);
        setShowAlert(true);
        setDescriptionAlert(ALERT_ADD_PLANS);
        showToastSuccessMessage(TOAST_PAYMENT_MODE_ADDED, typeAlert.success, setSeeToast);
        setOpenDrawerPaymentM(false);
        setDisablePlans(false);
        accountTypes.clearCreated();
    }, [accountTypes.created]);
    useEffect(function () {
        if (!Array.isArray(recurrences.items))
            return;
        if (recurrences.items.length === 0) {
            setDisableRecurrence(false);
            setShowAddButtonRecurrence(true);
            setShowAddButtonPaymentMode(true);
        }
    }, [recurrences.items]);
    useEffect(function () {
        if (!Array.isArray(accountTypes.items))
            return;
        if (accountTypes.items.length === 0) {
            setShowAddButtonPaymentMode(true);
        }
    }, [accountTypes.items]);
    useEffect(function () {
        if (productPlans.plans && productPlans.plans.length > 0) {
            setDisableFlags(false);
        }
    }, [productPlans.plans]);
    useEffect(function () {
        var _a, _b, _c;
        var detail = product.product;
        if (!detail)
            return;
        setDataProductCreation({
            IdSponsor: detail.sponsorId,
            IdTypeInsurance: detail.projectTypeId,
            Description: detail.description,
            Code: detail.code,
            IdCurrency: detail.currencyId,
            CertifyNumber: detail.certId,
            QuotesNumber: detail.countPolicy,
            PolicyNumber: detail.countQuote,
            isIframe: (_a = detail.metadata) === null || _a === void 0 ? void 0 : _a.iframe,
            IframeUrl: (_b = detail.metadata) === null || _b === void 0 ? void 0 : _b.iframeUrl,
        });
        setImgProject(detail.logoUrl);
        var campaigns = (_c = detail.campaign) !== null && _c !== void 0 ? _c : [];
        if (campaigns.length > 0) {
            setCampaignId(campaigns[0].id);
            campaign.fetch(campaigns[0].id);
        }
        else {
            setIsUpdate(false);
            setActivateEditCampaign(true);
            setShowButtonAddCampaign(true);
            setShowAddButtonPaymentMode(true);
            setShowAddButtonRecurrence(true);
        }
    }, [product.product]);
    useEffect(function () {
        var detail = campaign.campaign;
        if (!detail)
            return;
        setDataCampaignCreation({
            CampaignName: detail.name,
            CodeCampaign: detail.code,
            StartDateCampaign: formattedDateYYMMDD(detail.startDate),
            EndDateCampaign: formattedDateYYMMDD(detail.endDate),
        });
    }, [campaign.campaign]);
    useEffect(function () {
        if (!deleteEntity.entityDeleted)
            return;
        loadRecurrences(currentProjectId);
        loadAccountTypes(currentProjectId);
        deleteEntity.clearDeleted();
    }, [deleteEntity.entityDeleted]);
    var handleSubmitProduct = function (data, fileImg) {
        var body = {
            code: data.Code,
            description: data.Description,
            certId: data.CertifyNumber,
            countQuote: isUpdate
                ? data.QuotesNumber
                : parseInt(String(data.QuotesNumber)),
            countPolicy: isUpdate
                ? data.PolicyNumber
                : parseInt(String(data.PolicyNumber)),
            sponsorId: data.IdSponsor,
            projectTypeId: data.IdTypeInsurance,
            currencyId: data.IdCurrency,
            metadata: {
                iframe: data.isIframe,
                iframeUrl: data.IframeUrl,
            },
        };
        if (isUpdate) {
            saveProduct.updateProduct({ id: currentProjectId, body: body });
        }
        else {
            setDataProductCreation(data);
            saveProduct.createProduct(body);
        }
        setUploadedImage(fileImg);
    };
    var handleSubmitCampaign = function (data) {
        var body = {
            name: data.CampaignName,
            code: data.CodeCampaign,
            startDate: data.StartDateCampaign,
            endDate: data.EndDateCampaign,
        };
        if (isUpdate) {
            saveCampaign.updateCampaign({ id: campaignId, body: body });
        }
        else {
            setDataCampaignCreation(data);
            saveCampaign.createCampaign(body);
        }
    };
    var handleSubmitPaymentRecurrence = function (data) {
        var _a;
        recurrences.create({
            projectId: currentProjectId,
            catalogPaymentModeId: (_a = data.paymentRecurrence) !== null && _a !== void 0 ? _a : "",
        });
    };
    var handleSubmitAccountType = function (data) {
        var _a;
        accountTypes.create({
            projectId: currentProjectId,
            catalogAccountTypeId: (_a = data.paymentMode) !== null && _a !== void 0 ? _a : "",
        });
    };
    var clickContextMenuRecurrence = function (item) {
        var _a;
        setOpenModal(true);
        setDeleteModal({
            title: DELETE_TITLE_RECURRENCE,
            subTitle: deleteSubTitleRecurrence(item.description),
            target: "recurrence",
            id: (_a = item.id) !== null && _a !== void 0 ? _a : "",
        });
    };
    var clickContextMenuPaymentMode = function (item) {
        var _a;
        setOpenModal(true);
        setDeleteModal({
            title: DELETE_TITLE_PAYMENT_MODE,
            subTitle: deleteSubTitlePaymentMode(item.description),
            target: "paymentMode",
            id: (_a = item.id) !== null && _a !== void 0 ? _a : "",
        });
    };
    var onConfirmDelete = function () {
        if (!deleteModal)
            return;
        setOpenModal(false);
        deleteEntity.deleteEntity({
            id: deleteModal.id,
            entity: deleteModal.target === "recurrence"
                ? DELETE_ENTITY_RECURRENCE
                : DELETE_ENTITY_PAYMENT_MODE,
            userId: lsLogin.getUserLoginStored().userId,
        });
    };
    var clickContextMenuPlans = function (item) {
        navigate(routePlanCreation(currentProjectId, item.id));
    };
    var columnsRecurrence = buildRecurrenceColumns(canEdit, clickContextMenuRecurrence);
    var columnsPaymentMode = buildPaymentModeColumns(canEdit, clickContextMenuPaymentMode);
    var columnsPlans = buildPlansColumns(canEdit, clickContextMenuPlans);
    var columnsFlags = buildFlagsColumns(canEdit);
    var loading = lookups.loading ||
        saveProduct.loadingCreate ||
        saveCampaign.loadingCreate ||
        recurrences.loadingCreate ||
        accountTypes.loadingCreate ||
        product.loading ||
        saveProduct.loadingUpdate ||
        saveCampaign.loadingUpdate ||
        deleteEntity.loading;
    return {
        loading: loading,
        loadingText: saveProduct.loadingUpdate || saveCampaign.loadingUpdate
            ? UPDATING_TEXT
            : LOADING_TEXT,
        seeToast: seeToast,
        closeToast: function () { return setSeeToast(HIDDEN_TOAST); },
        view: {
            permissions: PRODUCT_PERMISSIONS,
            disableCampaign: disableCampaign,
            disableRecurrence: disableRecurrence,
            disablePaymentMode: disablePaymentMode,
            disablePlans: disablePlans,
            disableFlags: disableFlags,
            insuranceTypeList: lookups.insuranceTypeList,
            sponsorList: lookups.sponsorList,
            currencyList: lookups.currencyList,
            paymentModeList: paymentModeList,
            accountTypeList: accountTypeList,
            dataProductCreation: dataProductCreation,
            dataCampaignCreation: dataCampaignCreation,
            handleSubmitProduct: handleSubmitProduct,
            handleSubmitCampaign: handleSubmitCampaign,
            handleSubmitPaymentRecurrence: handleSubmitPaymentRecurrence,
            handleSubmitAccountType: handleSubmitAccountType,
            showAlert: showAlert,
            setShowAlert: setShowAlert,
            descriptionAlert: descriptionAlert,
            setDescriptionAlert: setDescriptionAlert,
            autoClose: PRODUCT_ALERT_AUTO_CLOSE,
            autoCloseActive: false,
            activateEditProduct: activateEditProduct,
            activateEditCampaign: activateEditCampaign,
            panelActive: panelActive,
            rowsPaymentRecurrence: rowsPaymentRecurrence,
            rowsAccountType: rowsAccountType,
            rowsPlans: rowsPlans,
            rowsFlags: rowsFlags,
            showButtonsActions: showButtonsActions,
            showButtonAddRecurrence: showAddButtonRecurrence,
            showButtonAddPaymentMode: showAddButtonPaymentMode,
            showAddButtonPlans: showAddButtonPlans,
            showCancelButton: showCancelButton,
            showButtonAddCampaign: showButtonAddCampaign,
            showUploadButton: showUploadButton,
            idProduct: idProduct,
            isEdit: isEdit,
            imgProject: imgProject,
            setIsUpdate: setIsUpdate,
            setShowCancelButton: setShowCancelButton,
            onClickBack: function () { return navigate(-1); },
            onClickAddPlans: function () { return navigate(routePlanCreation(currentProjectId)); },
            columnsRecurrence: columnsRecurrence,
            columnsPaymentMode: columnsPaymentMode,
            columnsPlans: columnsPlans,
            columnsFlags: columnsFlags,
            openDrawerPaymentR: openDrawerPaymentR,
            setOpenDrawerPaymentR: setOpenDrawerPaymentR,
            openDrawerPaymentM: openDrawerPaymentM,
            setOpenDrawerPaymentM: setOpenDrawerPaymentM,
            openModal: openModal,
            setOpenModal: setOpenModal,
            titleDelete: (_a = deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.title) !== null && _a !== void 0 ? _a : "",
            subTitleDelete: (_b = deleteModal === null || deleteModal === void 0 ? void 0 : deleteModal.subTitle) !== null && _b !== void 0 ? _b : "",
            onConfirmDelete: onConfirmDelete,
        },
    };
};
